define.alias("shared/components/shared/post/secondary/activity/footer", "media/components/shared/post/secondary/activity/footer");